import React, { useState } from "react";
import Combobox from "./Combobox";
import { suggestCategoryCode, validateCategoryCode } from "../utils/categoryCode";

export default function CategoryPicker({ value, categories = [], onChange, onNewCategory, id }) {
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState("");
  const [newCode, setNewCode] = useState("");
  const [codeTouched, setCodeTouched] = useState(false);

  const existingCodes = categories.map((c) => c.code);

  const options = categories.map((c) => ({
    value: c.name,
    primary: c.name,
    secondary: c.code,
    search: String(c.name).toLowerCase(),
  }));

  const selectedCat = categories.find(
    (c) => String(c.name).trim().toUpperCase() === String(value || "").trim().toUpperCase()
  ) || null;

  const collapse = () => {
    setAdding(false);
    setNewName("");
    setNewCode("");
    setCodeTouched(false);
  };

  const nm = newName.trim();
  // Disabled-control sweep (manual-testing report): a blank name used to return "" here, unlike
  // this same panel's own `codeError` (`validateCategoryCode`, already says "wajib diisi" for
  // blank) — Tambah sat disabled with nothing explaining why for this one specific field.
  const nameError = !nm
    ? "Wajib diisi."
    : categories.some((c) => String(c.name).trim().toUpperCase() === nm.toUpperCase())
      ? "Kategori sudah ada — pilih dari daftar."
      : "";
  const codeError = validateCategoryCode(newCode, existingCodes);

  const handleAddName = (e) => {
    const v = e.target.value;
    setNewName(v);
    if (!codeTouched) setNewCode(suggestCategoryCode(v, existingCodes));
  };

  const handleAddCode = (e) => {
    setCodeTouched(true);
    setNewCode(e.target.value.toUpperCase());
  };

  const handleTambah = () => {
    if (!nm || nameError || codeError) return;
    const code = newCode.trim().toUpperCase();
    if (onNewCategory) onNewCategory({ name: nm, code });
    onChange(nm);
    collapse();
  };

  // The picker (dropdown + "Tambah kategori baru") shows ONLY when no category is assigned.
  // A filled value collapses to a summary chip with "Ganti"; "Ganti" clears the value (Fix A),
  // returning here so the user can pick a different existing category OR create a new one.
  const showPicker = !value;

  return (
    <div>
      {showPicker ? (
        <>
          <Combobox
            id={id}
            options={options}
            value={value || ""}
            onChange={(v) => onChange(v || null)}
            allowCreate={false}
            placeholder="— pilih kategori —"
          />
          {!adding && (
            <div style={{ marginTop: "var(--gap-sm)" }}>
              <button type="button" className="btn btn-soft btn-block" onClick={() => setAdding(true)}>
                <span className="btn-circle-plus" aria-hidden="true">+</span>
                Tambah kategori baru
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="cat-summary">
          <span className="cat-summary__name">{value}</span>
          {selectedCat?.code && <span className="cat-summary__code">{selectedCat.code}</span>}
          <span className="cat-summary__spacer" />
          <button type="button" className="btn btn-sm" onClick={() => onChange(null)}>Ganti</button>
        </div>
      )}

      {/* Add panel: render independently so "Batal" returns to the correct state (value still empty → picker). */}
      {adding && (
        <div style={{ border: "1px solid var(--border)", borderRadius: 6, padding: 12, marginTop: "var(--gap-sm)" }}>
          <div className="form-row">
            <label className="form-label" htmlFor="cat-picker-nama">Nama kategori</label>
            <input id="cat-picker-nama" className="form-input" value={newName} autoFocus onChange={handleAddName} />
            {nameError && <div className="form-hint" style={{ color: "var(--red)" }}>{nameError}</div>}
          </div>
          <div className="form-row">
            <label className="form-label" htmlFor="cat-picker-kode">Kode</label>
            <input id="cat-picker-kode" className="form-input mono" value={newCode} onChange={handleAddCode} />
            {codeError && <div className="form-hint" style={{ color: "var(--red)" }}>{codeError}</div>}
          </div>
          <div className="modal-actions" style={{ marginTop: "var(--gap-sm)" }}>
            <button type="button" className="btn" onClick={collapse}>Batal</button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={!nm || !!nameError || !!codeError}
              onClick={handleTambah}
            >
              Tambah
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
